import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

import { WhatsAppButton } from "@/app/ui/WhatsAppButton";
import HotelsList from "@/features/hotels/components/hotels-list/HotelsList";
import { useHotelBookingContext } from "@/features/hotels/contexts/HotelBookingContext";

export const Route = createFileRoute("/_authenticated/_hotels/hotels/list")({
  component: RouteComponent,
});

function RouteComponent() {
  const { resetBooking } = useHotelBookingContext();

  useEffect(() => {
    resetBooking();
  }, [resetBooking]);

  return (
    <main className="no-footer main h-screen">
      <HotelsList />
      <WhatsAppButton />
    </main>
  );
}
